import React from 'react';
import PropTypes from 'prop-types';
import YoutubeVideoEmbed from 'epic-react-common/src/components/YoutubeVideoEmbed';
import {Gallery} from '../../components';

export default class TabSection extends React.PureComponent {
    static propTypes = {
        contentSection: PropTypes.object.isRequired
    };

    state = {
        tabSelected: 'tabInfo',
        activeVideo: 0
    };

    setTab = (e) => {
        e.preventDefault();
        const tab = e.currentTarget.id;
        this.setState({
            tabSelected: tab
        });
    };

    nextVideo = () => {
        this.setState({
            activeVideo: this.state.activeVideo + 1
        });
    };

    preVideo = () => {
        this.setState({
            activeVideo: this.state.activeVideo - 1
        });
    };

    videoOptions = {
        playerVars: {
            width: '100%',
            height: '450',
            controls: 1,
            autohide: 0,
            cc_load_policy: 0,
            disablekb: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            rel: 0,
            loop: 0
        }
    };

    render() {
        const {contentSection} = this.props;
        const videoIds = contentSection.videoBlock.videoId;
        const images = [];
        for (const obj of contentSection.screenshotsBlock.imageBlock) {
            for (const image of obj.images) {
                const temp = {};
                temp.src = image.screenshot;
                temp.thumbnail = image.thumbnail;
                images.push(temp);
            }
        }

        return (
            <section className="activity row no-mar-bot" >
                <div className="grid">
                    <div className="col l12">
                        <ul className="subNavTab">
                            <li
                                role="presentation"
                                id="tabInfo"
                                className={this.state.tabSelected === 'tabInfo' ? 'tabSelected' : ''}
                                onClick={this.setTab}>
                                <span>{contentSection.infoBlock.blockTitle}</span>
                            </li>
                            <li
                                role="presentation"
                                id="tabVideo"
                                className={this.state.tabSelected === 'tabVideo' ? 'tabSelected' : ''}
                                onClick={this.setTab}>
                                <span>{contentSection.videoBlock.blockTitle}</span>
                            </li>
                            <li
                                role="presentation"
                                id="tabGallery"
                                className={this.state.tabSelected === 'tabGallery' ? 'tabSelected' : ''}
                                onClick={this.setTab}>
                                <span>{contentSection.screenshotsBlock.blockTitle}</span>
                            </li>
                        </ul>
                        <ul className="tabContainer">
                            <li id="tab-info-content" className={`row no-mar-bot ${this.state.tabSelected === 'tabInfo' ? 'active' : ''}`}>
                                <div className="col l6 leftPart m12 s12">
                                    <div dangerouslySetInnerHTML={{__html: contentSection.infoBlock.videoDescription}} />
                                    <br />
                                    <hr />
                                    <dl>
                                        <dd dangerouslySetInnerHTML={{__html: contentSection.infoBlock.description}} />
                                    </dl>
                                </div>

                                <div className="gem-stone-box">
                                    <img src={contentSection.gemStone} alt="Gemstone" />
                                </div>
                            </li>
                            <li id="tab-video-content" className={`row no-mar-bot ${this.state.tabSelected === 'tabVideo' ? 'active' : ''}`}>
                                <ul className="video col l12">
                                    <div
                                        role="presentation"
                                        className={`prev-video-block ${this.state.activeVideo === 0 ? 'hidden' : ''}`}
                                        onClick={this.preVideo}>
                                        <i className="icon-chevron_left" />
                                    </div>
                                    <div
                                        role="presentation"
                                        className={`next-video-block ${this.state.activeVideo === videoIds.length - 1 ? 'hidden' : ''}`}
                                        onClick={this.nextVideo}>
                                        <i className="icon-chevron_right" />
                                    </div>
                                    {
                                        videoIds.map((id, index) => (
                                            <div
                                                className={`iframe-container ${this.state.activeVideo === index ? 'active' : ''}`}
                                                key={`video-${id}`}>
                                                <div className="iframe-block">
                                                    <YoutubeVideoEmbed
                                                        id={`info-player-${index}`}
                                                        className="player"
                                                        video={id}
                                                        videoOptions={this.videoOptions}
                                                        mute={false}
                                                        loop={true}
                                                        play={this.state.activeVideo === index && this.state.tabSelected === 'tabVideo'} />
                                                </div>
                                            </div>
                                        ))
                                    }
                                </ul>
                            </li>
                            <li id="tab-gallery-content" className={`row no-mar-bot ${this.state.tabSelected === 'tabGallery' ? 'active' : ''}`}>
                                <Gallery
                                    images={images}
                                    rawImages={contentSection.screenshotsBlock.imageBlock} />
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        );
    }
}
